/**
	* @readonly
	* @enum {number}
	*/
export const PackageType = Object.freeze({
	Invalid: 0,
	SCORM_12: 1,
	SCORM_2004v2: 2,
	SCORM_2004v3: 3,
	xAPI: 4,
	xAPI_CAPTIVATE: 5,
	xAPI_STORYLINE: 6
});

export const MediaType = Object.freeze({
	Video: 1,
	Interactive: 2,
});

export const PackageTypeToMediaType = Object.freeze({
	[PackageType.xAPI_CAPTIVATE]: MediaType.Interactive,
	[PackageType.xAPI_STORYLINE]: MediaType.Interactive,
	[PackageType.xAPI]: MediaType.Video,
	[PackageType.SCORM_12]: MediaType.Video,
	[PackageType.SCORM_2004v2]: MediaType.Video,
	[PackageType.SCORM_2004v3]: MediaType.Video,
	[PackageType.Invalid]: MediaType.Video,
});

export function packageIsScorm(packageType) {
	return (packageType === PackageType.SCORM_12 || packageType === PackageType.SCORM_2004v2 || packageType === PackageType.SCORM_2004v3);
}

export function getPackageTypeString(packageType) {
	const packageStringMap = {
		[PackageType.SCORM_12]: "SCORM 1.2",
		[PackageType.SCORM_2004v2]: "SCORM 2004 2nd Edition",
		[PackageType.SCORM_2004v3]: "SCORM 2004 3rd Edition",
		[PackageType.xAPI]: "xAPI",
		[PackageType.xAPI_CAPTIVATE]: "xAPI (Adobe Captivate)",
		[PackageType.xAPI_STORYLINE]: "xAPI (Articulate Storyline)"
	};
	return packageStringMap[packageType] ?? "Invalid";
}